export class HistoricoStatus  {
    lead: number;
    agendados: number;
    inscritos: number;
    leadRDStation: number;
    matriculados: number;
    aprovado: number;
    naoAprovado: number;
    naoCompareceu: number;   
}